<template>
  <div class="provider-links">
    <div class="text-h6 font-weight-semibold mb-5">
      Proveedores
    </div>
    <div class="d-flex flex-column">
      <router-link :to="{name: 'joinus'}">
        Soy un proveedor
      </router-link>
      <router-link :to="{name: 'website'}">
        Crea tu página de proveedor
      </router-link>
      <router-link :to="{name: 'suscriptionplans'}" v-if="false">
        Planes de suscripción
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProviderLinks',
};
</script>

<style lang="scss" scoped>
.provider-links {
  a {
    line-height: 27px;
    color:#fff!important;
  }
}
</style>
